import { z } from 'zod';
import { exportPreferenceFields } from './export-preferences.mjs';
import { boundedSchema, id, text, unique } from './common.mjs';
import { textRunSchema } from './value.mjs';
import { nativePresentationFields, BOX_SPACING } from './presentation.mjs';
import { nativeImageNodeSchema } from './image.mjs';

const runs = z.array(textRunSchema).max(500);
const blockPresentation = nativePresentationFields({
  colours: ['text', 'background', 'border'],
  spacing: BOX_SPACING,
});
export const documentBlockSchema = z.discriminatedUnion('kind', [
  z.object({ id, ...blockPresentation, kind: z.literal('paragraph'), runs }).strict(),
  z
    .object({
      id,
      ...blockPresentation,
      kind: z.literal('heading'),
      level: z.union([z.literal(1), z.literal(2), z.literal(3)]),
      runs,
    })
    .strict(),
  z
    .object({
      id,
      ...blockPresentation,
      kind: z.literal('list'),
      ordered: z.boolean(),
      items: z.array(z.object({ id, runs }).strict()).max(500),
    })
    .strict(),
  z.object({ id, kind: z.enum(['table', 'chart']), registeredPayloadRef: id }).strict(),
  nativeImageNodeSchema,
]);

export function documentNodeIds(payload) {
  return payload.blocks.flatMap((block) => [
    block.id,
    ...(block.runs ?? []).map((r) => r.id),
    ...(block.items ?? []).flatMap((item) => [item.id, ...item.runs.map((r) => r.id)]),
  ]);
}
export const documentPayloadSchema = boundedSchema(
  z
    .object({
      ...exportPreferenceFields,
      schemaVersion: z.literal(1),
      id,
      title: text(300),
      blocks: z.array(documentBlockSchema).min(1).max(2000),
    })
    .strict()
    .superRefine((v, ctx) => unique(documentNodeIds(v), ctx, ['blocks'])),
);
